module.exports = __webpack_public_path__ + "static/media/05.17ebe12a.jpg";